// @flow

import { push } from 'react-router-redux'

import { getUserData } from './user'
import { getUsers } from './users'
import { fetchManifest } from './manifest'
import { clearSearchFilters } from './questsfilters'
import { clearReviewQueueFilters } from './reviewqueuefilters'
import { clearQueueFilters } from './queuefilters'
import { clearProductionStatusFilters } from './productionstatusfilters'
import { setDefaultMyQuestsFilters } from './myquests'
import { fetchTags } from './tags'
import { postLoggingInfo } from './logging'
import { getDefaultRoute } from '../utils/routes'
import { fetchMockCourses } from './mockcourses'
import type { Action } from '../types/actions/organization'

export const SET_CURRENT_ORGANIZATION = 'SET_CURRENT_ORGANIZATION'
export const SET_CURRENT_ORGANIZATION_ROLES = 'SET_CURRENT_ORGANIZATION_ROLES'
export const IS_CHANGING_CURRENT_ORGANIZATION =
  'IS_CHANGING_CURRENT_ORGANIZATION'
export const IS_NOT_CHANGING_CURRENT_ORGANIZATION =
  'IS_NOT_CHANGING_CURRENT_ORGANIZATION'

export function setCurrentOrganizationAction(orgId: number): Action {
  return {
    type: SET_CURRENT_ORGANIZATION,
    orgId: orgId
  }
}

export function setCurrentOrganizationRoles(roles: Array<string>): Action {
  return {
    type: SET_CURRENT_ORGANIZATION_ROLES,
    roles: roles
  }
}

export function isChangingCurrentOrganization() {
  return {
    type: IS_CHANGING_CURRENT_ORGANIZATION
  }
}

export function isNotChangingCurrentOrganization() {
  return {
    type: IS_NOT_CHANGING_CURRENT_ORGANIZATION
  }
}

export function setCurrentOrganization(
  orgId: number,
  roles: Array<string>,
  refreshData: ?boolean
): Function {
  return async (dispatch, getState) => {
    // refresh data happens when user manually changes organizations
    if (refreshData) {
      await dispatch(isChangingCurrentOrganization())
      await dispatch(clearSearchFilters())
      await dispatch(clearReviewQueueFilters())
      await dispatch(clearQueueFilters())
      await dispatch(clearProductionStatusFilters())
      await dispatch(setDefaultMyQuestsFilters())
      await dispatch(setCurrentOrganizationAction(orgId))
      await dispatch(setCurrentOrganizationRoles(roles))
      await dispatch(getUsers())
      await dispatch(getUserData())
      await dispatch(fetchManifest())
      await dispatch(fetchTags())
      await dispatch(fetchMockCourses())
      await dispatch(
        postLoggingInfo('user', {
          action: 'org_switch'
        })
      )

      const route = await getDefaultRoute(roles)
      await dispatch(push(route))
      await dispatch(isNotChangingCurrentOrganization())
    } else {
      // this happens on login
      await dispatch(setCurrentOrganizationAction(orgId))
      await dispatch(
        postLoggingInfo('user', {
          action: 'org_switch'
        })
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/organization.js